module.exports = __webpack_public_path__ + "01ea978f/img/search-filter-icon.c4751a52.svg";